import { type PropsWithChildren } from "react"

import { StatusBadge } from "~/components/design-system/components"
import { type StatusColor } from "~/constants/status"
import { cn } from "~/utils/helpers"

type Props = PropsWithChildren<{
  badge?: { text: string; color: StatusColor }
  className?: string
}>

/**
 * The surface an AG Grid cell tooltip uses to say something rather than plot it, optionally led by
 * a StatusBadge naming the state. Sole owner of its tokens, so every such tooltip looks the same.
 */
export default function TooltipMessageCard({ badge, className, children }: Props) {
  return (
    <div
      className={cn(
        "bg-base shadow-tooltip text-fg-base px-2 py-1.5 rounded-md paragraph-sm whitespace-pre-line",
        // Width belongs here, not on the caller: a message is prose, and unconstrained it renders
        // as one line far past the ~65 characters the eye can track back from.
        "max-w-70",
        badge && "flex flex-col items-start gap-1.5",
        className,
      )}
    >
      {badge && <StatusBadge text={badge.text} color={badge.color} />}
      {children}
    </div>
  )
}
